import registrationApi from './registrationApi';

export const verifyEmailByTokenAndRegister = (verifyEmailAndRegisterApiProvider = registrationApi) => {
  return async (
    token,
    registrationUrl,
    setErrorType,
    setStep,
    setIsOpen,
  ) => {
    try {
      const { status, error, data } = await verifyEmailAndRegisterApiProvider(
        registrationUrl,
        { emailCode: '', emailUrlToken: token },
      );

      if (status === 200) {
        setStep('SUCCESS');
        if (data?.redirectUrl) {
          return window.location.assign(data.redirectUrl);
        }
      } else if (error) {
        setStep('LINK_EXPIRED');
        setErrorType(error.type || 'unauthorized');
      }

      setIsOpen(true);
    } catch (error) {
      console.error(error)
    }
  };
};

export default verifyEmailByTokenAndRegister(registrationApi);
